import React, { useEffect, useState, lazy } from 'react';
import { CTAButton } from './CTAButton';
import { BadgeCheckIcon, ChevronLeftIcon, ChevronRightIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
const resultImages = ['https://cdn.magicpatterns.com/uploads/eUXr1L2ENfAzbQbbbmot7u/ad3.jpg', 'https://cdn.magicpatterns.com/uploads/7i74A1uN2D5Dy3E6WCpqoi/ChatGPT_Image_29_abr_2026,_07_21_51_p.m..png', 'https://cdn.magicpatterns.com/uploads/7h1qPU2exeCiQA1AgFwB9M/5.jpg', 'https://cdn.magicpatterns.com/uploads/qS5YCMNmBBeqUf22EATP66/ad7.jpg', 'https://cdn.magicpatterns.com/uploads/fs4t5fx5ZfJXFUVgXYYmCu/ad2.jpg'];
const results = [{
  label: 'TIENDA 1',
  amount: 'USD 39,167',
  image: 'https://cdn.magicpatterns.com/uploads/8iQb4yV17KvLsVexiE4yF4/TIENDA_1.jpg'
}, {
  label: 'TIENDA 2',
  amount: 'USD 17,500',
  image: 'https://cdn.magicpatterns.com/uploads/e5774hAGZz8777oghUPigq/TIENDA_2.jpg'
}, {
  label: 'TIENDA 3',
  amount: 'USD 35,117',
  image: 'https://cdn.magicpatterns.com/uploads/ttY5TSkg5grcyCbbsyQbQJ/TIENDA_3.png'
}];
export function RealResultsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [heroSlide, setHeroSlide] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % results.length);
    }, 4000);
    return () => clearInterval(timer);
  }, []);
  useEffect(() => {
    const timer = setInterval(() => {
      setHeroSlide(prev => (prev + 1) % resultImages.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const goPrev = () => setCurrentSlide(prev => (prev - 1 + results.length) % results.length);
  const goNext = () => setCurrentSlide(prev => (prev + 1) % results.length);
  const goHeroPrev = () => setHeroSlide(prev => (prev - 1 + resultImages.length) % resultImages.length);
  const goHeroNext = () => setHeroSlide(prev => (prev + 1) % resultImages.length);
  return <section className="py-8 md:py-12 px-4 bg-[#2E0640] pt-[10px] pb-[10px]" data-id="element-282" data-mp="25y52zepeauhp">
      <div className="max-w-6xl mx-auto" data-id="element-283" data-mp="1r98kenpppz2u">
        <div className="text-center mb-12" data-id="element-284" data-mp="1raa75pg3ca0e">
          <h2 className="md:text-5xl font-black text-white mb-4 pt-[0px] pb-[0px] text-[28px]" data-id="element-285" data-mp="1w70m29g5szk8">
            Quiénes somos y por qué podemos enseñarte?
          </h2>

          {/* Static image */}
          <div className="max-w-md mx-auto mb-8" data-id="element-286" data-mp="2owr4guotqnm5">
            <div className="overflow-hidden rounded-2xl shadow-xl" data-id="element-287" data-mp="2ovfyqpbtj5se">
              <img src="https://cdn.magicpatterns.com/uploads/jpjQ2WmqW9RXQDsFySuAuF/Historias_Destacadas.png" alt="Brenda y Nasser - Quiénes somos" loading="lazy" className="w-full object-cover" data-id="element-288" data-mp="29xx2z30q3sbg" />
            </div>
          </div>

          <p className="text-xl max-w-3xl mx-auto text-[#D9D9D9] pt-[0px] pb-[0px] mt-[-20px] mb-[-20px]" data-id="element-289" data-mp="13jnybvy9ilpc">
            Somos Nasser Khoder y Brenda H. Emprendores +10 años experiencia,
            Infoproductores, MKT, Creadores de Contenido, Marcas Personales y
            grandes comunidades❤️
          </p>

          <section aria-labelledby="autoridad-title" className="mx-auto mt-12 max-w-5xl rounded-3xl border border-white/15 bg-[#11131A] px-5 py-8 shadow-2xl md:px-10 md:py-10" data-id="element-290" data-mp="3qqshprlk3d6a">
            <header className="mx-auto max-w-3xl" data-id="element-291" data-mp="2yy1s3zydomq0">
              <p className="text-sm font-black uppercase tracking-[0.18em] text-[#FC9DFF]" data-id="element-292" data-mp="2u1uls622l97j">
                Confianza y tranquilidad
              </p>
              <h3 id="autoridad-title" className="mt-3 text-2xl font-black text-white md:text-4xl" data-id="element-293" data-mp="37ukk99ysc6lj">
                Dominando Shopify, creado por personas reales
              </h3>
              <p className="mt-4 text-base leading-relaxed text-gray-300 md:text-lg" data-id="element-294" data-mp="2batlnep7r7me">
                Nasser Khoder y Brenda Hormaechea crearon este programa para
                compartir una metodología clara, con experiencia, cercanía y
                transparencia en cada paso.
              </p>
            </header>

            <ul className="mt-7 grid gap-3 text-left sm:grid-cols-3" data-id="element-295" data-mp="2xxp9ypbmkjd6">
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-296" data-mp="32ofc7tor863n">
                <BadgeCheckIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-297" data-mp="37obi5yh0i7lu" />
                <span className="text-sm font-bold text-white" data-id="element-298" data-mp="3bnkb5148a1gc">
                  Perfiles verificados
                </span>
              </li>
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-299" data-mp="3lnb8rbo34wkn">
                <ShieldCheckIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-300" data-mp="1mb8q23nac681" />
                <span className="text-sm font-bold text-white" data-id="element-301" data-mp="1rbmn6qnclvra">
                  +10 años de trayectoria
                </span>
              </li>
              <li className="flex items-center gap-3 rounded-xl border border-white/10 bg-black/30 px-4 py-3" data-id="element-302" data-mp="1ez119lnftgpu">
                <UsersIcon className="h-5 w-5 shrink-0 text-[#FC9DFF]" aria-hidden="true" data-id="element-303" data-mp="1a199crmsluln" />
                <span className="text-sm font-bold text-white" data-id="element-304" data-mp="14z0hxzpkj0ln">
                  +46,100 personas en Latinoamérica
                </span>
              </li>
            </ul>

            <div className="mt-8 grid justify-items-center gap-8 md:grid-cols-2" data-id="element-305" data-mp="1xqbo9rq1l9cg">
              <figure className="relative isolate w-full max-w-[300px]" data-id="element-306" data-mp="1spnxn75q6uir">
                <div className="pointer-events-none absolute -inset-8 -z-10 rounded-[3.5rem] bg-[#D946EF]/45 blur-3xl animate-pulse" aria-hidden="true" data-id="element-307" data-mp="1ns4atiuyp9f7" />
                <div className="relative overflow-hidden rounded-[2.5rem] border-[7px] border-[#FC9DFF]/80 bg-black p-1 shadow-[0_0_26px_rgba(252,157,255,0.8),0_0_70px_rgba(156,22,163,0.6),0_18px_45px_rgba(0,0,0,0.55)]" data-id="element-308" data-mp="cc68ryy7bnnh">
                  <div className="absolute left-1/2 top-2 z-10 h-5 w-28 -translate-x-1/2 rounded-full bg-[#090A0E]" aria-hidden="true" data-id="element-309" data-mp="34hvmxehza6lh" />
                  <img src="https://cdn.magicpatterns.com/uploads/hMPWdW3CzdFqBenYxkZP1m/WhatsApp_Image_2026-07-16_at_02.00.10.jpg" alt="Perfil verificado de Instagram de Brenda Hormaechea" loading="lazy" className="mt-5 w-full rounded-[2rem]" data-id="element-310" data-mp="2vlebea5pc6p7" />
                </div>
                <figcaption className="mt-3 text-sm font-bold text-gray-200" data-id="element-311" data-mp="2ctljkj2dcrj2">
                  Brenda Hormaechea — perfil verificado
                </figcaption>
              </figure>

              <figure className="relative isolate w-full max-w-[300px]" data-id="element-312" data-mp="22uw0wo2nf31r">
                <div className="pointer-events-none absolute -inset-8 -z-10 rounded-[3.5rem] bg-[#A855F7]/45 blur-3xl animate-pulse" aria-hidden="true" data-id="element-313" data-mp="1j8ko6cskj9mk" />
                <div className="relative overflow-hidden rounded-[2.5rem] border-[7px] border-[#C084FC]/80 bg-black p-1 shadow-[0_0_26px_rgba(192,132,252,0.8),0_0_70px_rgba(168,85,247,0.6),0_18px_45px_rgba(0,0,0,0.55)]" data-id="element-314" data-mp="1t6qmylj2vzn7">
                  <div className="absolute left-1/2 top-2 z-10 h-5 w-28 -translate-x-1/2 rounded-full bg-[#090A0E]" aria-hidden="true" data-id="element-315" data-mp="225vq655l4h5p" />
                  <img src="https://cdn.magicpatterns.com/uploads/bZYZewXzgeQBSDFLFnfrV6/WhatsApp_Image_2026-07-16_at_02.00.10_(1).jpg" alt="Perfil verificado de Instagram de Nasser Khoder" loading="lazy" className="mt-5 w-full rounded-[2rem]" data-id="element-316" data-mp="2bwqa32vcz4nz" />
                </div>
                <figcaption className="mt-3 text-sm font-bold text-gray-200" data-id="element-317" data-mp="11l1y8cb9tgus">
                  Nasser Khoder — perfil verificado
                </figcaption>
              </figure>
            </div>
          </section>

          <h3 className="text-2xl md:text-4xl font-black text-white mt-10 mb-2" data-id="element-318" data-mp="1bjrc7u01qh5r">
            Y podemos enseñarte porque tenemos{' '}
            <span className="underline decoration-4 decoration-yellow-400" data-id="element-319" data-mp="1gf6s0rhm6n4t">
              RESULTADOS
            </span>
          </h3>
          <p className="text-lg md:text-xl text-[#D9D9D9] mb-8 pt-[20px] pb-[20px]" data-id="element-320" data-mp="nsc5lp18ldop">
            Esto es lo que facturaron nuestras tiendas los últimos 6 meses👇
          </p>
        </div>

        {/* Carousel */}
        <div className="max-w-lg mx-auto mt-[-35px] mb-[-35px]" data-id="element-321" data-mp="xjqdak3cdjsx">
          <div className="bg-gray-800 rounded-2xl overflow-hidden animate-neon-violet" data-id="element-322" data-mp="3j8hp8vozsi">
            {/* Image carousel */}
            <div className="relative" data-id="element-323" data-mp="51kqe6ukit2e">
              <div className="overflow-hidden" data-id="element-324" data-mp="50ji2a4xskod">
                <div className="flex transition-transform duration-700 ease-in-out" style={{
                transform: `translateX(-${currentSlide * 100}%)`
              }} data-id="element-325" data-mp="2id5oea0xc48u">
                  {results.map((result, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-326" data-mp="24de4jsnq7tmx" data-mpi={index}>
                      <div className="p-4 text-center" data-id="element-327" data-mp="24f8p35v35jqh">
                        <span className="text-sm font-bold text-green-400 tracking-widest" data-id="element-328" data-mp="1zel2cwdw3p22">
                          {result.label}
                        </span>
                      </div>
                      <div className="px-4" data-id="element-329" data-mp="1qmj2az7qgasb">
                        <div className="overflow-hidden rounded-lg" style={{
                      height: '280px'
                    }} data-id="element-330" data-mp="1qj3mtva5czqd">
                          <img src={result.image} alt={`${result.label} - Resultados de ventas`} loading="lazy" className="w-full h-full object-cover object-top" data-id="element-331" data-mp="1bnp2dbza5njq" />
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>

              {/* Navigation arrows */}
              <button onClick={goPrev} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-332" data-mp="3tzgoixrcwvcq">
                <ChevronLeftIcon className="w-5 h-5" data-id="element-333" data-mp="6v0rwezkqo3e" />
              </button>
              <button onClick={goNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors z-10" data-id="element-334" data-mp="1vnwv6yjuapq">
                <ChevronRightIcon className="w-5 h-5" data-id="element-335" data-mp="1dbm9fksxrevp" />
              </button>
            </div>

            {/* Footer - shows current slide's data */}
            <div className="p-6 text-center" data-id="element-336" data-mp="1lty18qk662al">
              <p className="text-3xl md:text-4xl font-black text-green-400 mb-1 transition-all duration-500" data-id="element-337" data-mp="1ptox38ojz8lz">
                {results[currentSlide].amount}
              </p>
              <p className="text-gray-400 font-semibold text-sm" data-id="element-338" data-mp="1gsqnmavci8w0">
                FACTURACIÓN APROXIMADA EN USD
              </p>
            </div>
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-339" data-mp="24kp6ph11d8jp">
            {results.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full transition-all ${currentSlide === index ? 'bg-[#FC9DFF] scale-125' : 'bg-gray-500 hover:bg-gray-400'}`} data-id="element-340" data-mp="1usjdy52ymn3g" data-mpi={index} />)}
          </div>
        </div>

        <div className="text-center pt-[10px] pb-[10px]" data-id="element-341" data-mp="2s8ff9fjjnw35">
          <div className="inline-block px-8 py-3 rounded-full font-black text-[#FFFFFF] bg-[#9C16A3] animate-neon-violet text-[19px] mt-[60px] mb-[60px] pt-[12px] pb-[12px]" data-id="element-342" data-mp="2sa08n1u4h8zf">
            Si aplicas el método, en unas semanas puedes comenzar a generar entre
            USD 1,500 y USD 3,000 💰
          </div>
        </div>
      </div>
    </section>;
}